import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { LoadingSkeletonDirective2 } from 'common-ui';
import { IfInViewportDirective } from 'common-util';
import {
  createFixedGroupingStrategy,
  createMeasuredGroupingStrategy,
  GridCellDirective,
  GroupingStrategy,
  InfiniteGridLayoutComponent,
} from 'page-layouts-ui';
import { ProductId } from 'products-data';
import { ProductResultLayoutComponent } from '../product-result-layout';

@Component({
  selector: 'ideal-product-result-list',
  imports: [ProductResultLayoutComponent, IfInViewportDirective, GridCellDirective, InfiniteGridLayoutComponent, LoadingSkeletonDirective2],
  standalone: true,
  templateUrl: './product-result-list.component.html',
  styleUrls: ['./product-result-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.view]': 'view()',
  },
})
export class ProductResultListComponent {
  public readonly ids = input<(ProductId | null)[]>([]);
  public readonly view = input<'grid' | 'list'>('grid');
  public readonly itemLayout = computed(() => (this.view() === 'grid' ? 'card' : 'row'));

  protected readonly colStrategy: GroupingStrategy = createMeasuredGroupingStrategy(
    (containerWidth: number, minWidth: number, maxWidth: number, gap: number) => {
      if (this.itemLayout() === 'row') {
        return 1;
      }
      const availableWidth = containerWidth + gap;
      let itemWidth = minWidth + gap;
      let itemsPerRow = Math.floor(availableWidth / itemWidth);
      return itemsPerRow;
    },
  );
}
